import { useMemo as r } from "react";
import { useSearch as a, rootRouteId as g } from "@tanstack/react-router";
import { getCookie as m } from "../utils/cookies.js";
import { getValidatedMarketingParam as s, getMarketingCookies as u } from "../utils/marketing-params.js";
import { useConfig as t } from "./use-config.js";
function C(o) {
  const {
    generalConfig: { marketingSourceValidators: i }
  } = t(), { ...e } = a({
    from: g
  }), n = r(() => m(o), [o]);
  return s(
    (e == null ? void 0 : e[o]) ?? n,
    o,
    i
  );
}
function M() {
  const {
    generalConfig: { marketingSourceValidators: o }
  } = t();
  return r(
    () => u(o),
    [o]
  );
}
export {
  C as useMarketingAffiliateId,
  M as useMarketingCookies
};
